import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Sliders3_Vendor() {
      const [isScrolled, setIsScrolled] = useState(false);
    
      const settings = {
        slidesToShow: 7, 
        slidesToScroll: 1, 
        autoplay: true,
        autoplaySpeed: 2000, 
        arrows: false, 
        dots: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1024, // For screens smaller than 1024px
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 768, // For screens smaller than 768px
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 520, // For screens smaller than 520px
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };
    
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        setIsScrolled(scrollTop > 50);
      };
    
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
    
        const sliderRef = useRef(null);
      
        const play = () => {
          sliderRef.current.slickPlay();
        };
        const pause = () => {
          sliderRef.current.slickPause();
        };
  

  return (
    <div>
    <div className="about-company-main-sec">
    <div className="container">
        <div className="row">
            <div className="boxv1">
                <h5 className="tour-details-h5">Explore Top Pilgrimage Package</h5>
                <div className={`hotel-slides slider slides-wrapper ${ isScrolled ? "slider" : ""}`}>

                {/* <div className="pilgrimage-package-slides slider slides-wrapper"> */}
                <Slider ref={sliderRef} {...settings}>
                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/dwarka.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Dwarka</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/haridwar-and-rishikesh.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Haridwar</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img"
                             src="assets/img/pilgrimage/kashivishwanath.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Kashi Vishwanath</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/kumbh-mela.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Kumbh Mela</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/puri.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Puri</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/rameswaram.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Rameswaram</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/shirdi.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Shirdi</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img" 
                            src="assets/img/pilgrimage/trimbakeshwar.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Trimbakeshwar</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img"
                             src="assets/img/pilgrimage/tripatism.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Tirupati</div>
                        </a>
                    </div>

                    <div>
                        <a href="tirupati-tours-packages.php">
                            <img className="pilgrimage-package-img"
                             src="assets/img/pilgrimage/vaishno-devi.png"/>
                            <div className="_offrdate pilgrimage-title-vendors">Vaishno Devi</div>
                        </a>
                    </div>
                  </Slider>

                </div>

            </div>

        </div>
    </div>
    </div>
    </div>
  );
}

export default Sliders3_Vendor;
